import React, { useCallback } from "react";
import { graphql, useMutation } from "react-relay";
import {
  UserLoggedInNavigatorNavigationProp,
  UserLoggedInNavigatorRouteProp,
} from "../../../../../TopLevelNavigators/UserLoggedIn/UserLoggedInNavigatorParamList";
import { WidgetSizeT } from "../../localTypes/WidgetSizeT";

import { emaginWidgetSizes } from "../../WidgetAdd/utils/widgetSizes/emaginWidgetSizes";
import { WAIntegrationNotePreview } from "./WANoteIntegrationPreview";
import { withWebModal } from "@/src/TopLevelNavigators/UserLoggedIn/withWebModal";
import { View } from "react-native";
import { WAFakeHeader } from "../../WidgetAdd/WAFakeHeader";
import { useSizeClass } from "../../../../../common/Utils/useSizeClass";
import { SizeClass } from "@/src/common/Utils/SizeClass";
import { WANoteIntegrationMutation } from "./__generated__/WANoteIntegrationMutation.graphql";
import { WASizePreview } from "../../WidgetAdd/WASizePreview/WASizePreview";

type Props = {
  navigation: UserLoggedInNavigatorNavigationProp<"WidgetAddNoteIntegration">;
  route: UserLoggedInNavigatorRouteProp<"WidgetAddNoteIntegration">;
};

export const WANoteIntegration = withWebModal(WAIntegrationNoteC, true);
function WAIntegrationNoteC(props: Props) {
  const [createWidgetNote, loading] = useMutation<WANoteIntegrationMutation>(
    graphql`
      mutation WANoteIntegrationMutation(
        $storecastId: ID!
        $input: CreateWidgetNoteInput!
      ) {
        dashboard(dashboardId: $storecastId) {
          createWidgetNote(widget: $input) {
            id
          }
        }
      }
    `
  );

  const onCreate = useCallback(
    (size: WidgetSizeT) => {
      createWidgetNote({
        variables: {
          storecastId: props.route.params.storecastId,
          input: {
            positionX:
              props.route.params.position.x + props.route.params.position.c * 2,
            positionY: props.route.params.position.y,
            size: size.h === 1 ? "TWO_X_ONE" : "TWO_X_TWO",
            integrationId: props.route.params.integrationId,
            title: "",
          },
        },
        onCompleted: () => props.navigation.pop(2),
      });
    },
    [
      createWidgetNote,
      props.navigation,
      props.route.params.integrationId,
      props.route.params.position.c,
      props.route.params.position.x,
      props.route.params.position.y,
      props.route.params.storecastId,
    ]
  );
  const isCompact = useSizeClass().width === SizeClass.COMPACT;

  return (
    <View style={{ flex: 1 }}>
      {isCompact ? null : <WAFakeHeader />}
      <WASizePreview
        fullScreen
        loading={loading}
        maxSize={props.route.params.maxSize}
        onCreate={onCreate}
        unitSize={props.route.params.unitSize}
        widgetSizes={emaginWidgetSizes}
      >
        {(size) => (
          <WAIntegrationNotePreview
            widgetId={props.route.params.widgetId}
            size={size}
            storecastId={props.route.params.storecastId}
          />
        )}
      </WASizePreview>
    </View>
  );
}
